import React from "react";
import { FaFacebook, FaInstagram, FaTwitter, FaLinkedin } from "react-icons/fa";

function isEmptyOrSpaces(str) {
  return str === null || str === undefined || String(str).match(/^\s*$/) !== null;
}

const normalizeUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http") ? url : `https://${url}`;
};

const ClientSocialMediaLinks = ({ client, gotoWebsite, isDisabled }) => {
  const links = [
    {
      key: "facebook",
      label: "Facebook",
      url: client?.facebookUrl,
      icon: <FaFacebook />,
    },
    {
      key: "instagram",
      label: "Instagram",
      url: client?.instagramUrl,
      icon: <FaInstagram />,
    },
    {
      key: "twitter",
      label: "Twitter",
      url: client?.twitterUrl,
      icon: <FaTwitter />,
    },
    {
      key: "linkedin",
      label: "LinkedIn",
      url: client?.linkedinUrl,
      icon: <FaLinkedin />,
    },
  ].filter((item) => item.url && !isEmptyOrSpaces(item.url));

  if (links.length === 0) {
    return (
      <div className="gog-muted-block">
        No social media links available.
      </div>
    );
  }

  return (
    <div className="gog-social-links">
      {links.map((item) => (
        <button
          key={item.key}
          type="button"
          className={`gog-social-link ${item.key}`}
          disabled={isDisabled}
          title={item.label}
          onClick={() => {
            if (!isDisabled) {
              gotoWebsite(normalizeUrl(item.url));
            }
          }}
        >
          {item.icon}
          <span>{item.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ClientSocialMediaLinks;